/* eslint-disable */
import { useState } from "react";
import { useTranslation } from "react-i18next";

const AddEditPortfolioLinkModal = ({
  portfolioIndex,
  setPortfolioIndex,
  portfolioData,
  setPortfolioData,
  portfolioBlock,
  setPortfolioBlock,
}) => {
  const { t } = useTranslation(); //for translation
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!portfolioData.trim()) {
      newErrors.portfolioData = t("Portfolio link is required");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //function for add edcuation block
  const addPortfolioLinkHandler = () => {
    if (validateForm()) {
      setPortfolioBlock([...portfolioBlock, portfolioData]);
      closeModalHandler();
    }
  };

  //function for edit education block
  const editPortfolioBlockHandler = () => {
    if (validateForm()) {
      const updatedExperienceList = [...portfolioBlock];
      updatedExperienceList[portfolioIndex] = portfolioData;
      setPortfolioBlock(updatedExperienceList);
      closeModalHandler();
    }
  };

  //close modal handler
  const closeModalHandler = () => {
    setPortfolioData("");
    setPortfolioIndex(null);
    setErrors({});

    // close the modal of addLabel
    const bootstrapModal = document.querySelector("#savePortfolioLinkModal");
    const modal = bootstrap.Modal.getInstance(bootstrapModal);
    modal.hide();
  };

  return (
    <div
      className="modal fade"
      id="savePortfolioLinkModal"
      tabIndex="-1"
      aria-labelledby="addEducationModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15">
          {/* ------ modal head section start ----- */}
          <div className="modal-header bg-primary text-white px-4 py-3 border-bottom border-gray-300">
            <div className="d-flex align-items-center gap-3">
              <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
                <span className="material-symbols-outlined text-primary icon-md">
                  link
                </span>
              </div>
              <div>
                <h3
                  className="fw-bold fs-lg text-white mb-0"
                  id="addEducationModalLabel"
                >
                  {portfolioIndex != null
                    ? t("Update Portfolio Link")
                    : t("Add Portfolio Link")}
                </h3>
                <p className="text-white fs-sm mb-0">
                  {t("Configure your portfolio link details")}
                </p>
              </div>
            </div>
            <button
              type="button"
              className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModalHandler}
            ></button>
          </div>
          {/* ------ modal head section end ----- */}

          {/* ------ modal body section start ----- */}
          <div className="modal-body p-4">
            <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
              <form onSubmit={(e) => e.preventDefault()}>
                {/* <!-- ========== Start link input Section ========== --> */}
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  {" "}
                  <label
                    htmlFor="Grade"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    {t("Portfolio link")}
                  </label>
                  <input
                    type="text"
                    className={`form-control fs-sm shadow-none ${
                      errors.portfolioData
                        ? "is-invalid"
                        : "border border-gray-300"
                    }`}
                    placeholder={t("Enter portfolio link")}
                    value={portfolioData}
                    onChange={(e) => {
                      setPortfolioData(e.target.value);
                      if (errors.portfolioData) {
                        setErrors((prev) => ({ ...prev, portfolioData: "" }));
                      }
                    }}
                  />
                  {errors.portfolioData && (
                    <div className="invalid-feedback">
                      {errors.portfolioData}
                    </div>
                  )}
                </div>

                {/* <!-- ========== End link input Section ========== --> */}

                {/* ------ add/edit button start ----- */}
                <div className="action d-flex justify-content-end pt-3 border-top mt-4">
                  <button
                    type="button"
                    className="btn btn-primary d-flex align-items-center gap-2"
                    onClick={
                      portfolioIndex != null
                        ? editPortfolioBlockHandler
                        : addPortfolioLinkHandler
                    }
                  >
                    <span className="material-symbols-outlined me-1">save</span>{" "}
                    {portfolioIndex != null
                      ? t("Update Portfolio Link")
                      : t("Add Portfolio Link")}
                  </button>
                </div>
                {/* ------ add/edit button end ----- */}
              </form>
            </div>
          </div>
          {/* ------ modal body section end ----- */}
        </div>
      </div>
    </div>
  );
};

export default AddEditPortfolioLinkModal;
